const n = {
  id: "chartJsBackgroundColorPlugin",
  beforeDraw: (e, c, r) => {
    const {
      ctx: o,
      chartArea: { top: t, left: a, width: l, height: i }
    } = e;
    r.chartAreaBackgroundColor && (o.save(), o.globalCompositeOperation = "destination-over", o.fillStyle = r.chartAreaBackgroundColor, o.fillRect(a, t, l, i), o.restore()), r.backgroundColor && (o.save(), o.globalCompositeOperation = "destination-over", o.fillStyle = r.backgroundColor, o.fillRect(0, 0, e.width, e.height), o.restore());
  }
};
export {
  n as default
};
//# sourceMappingURL=index.es163.js.map
